module.exports = __webpack_public_path__ + "static/media/home.63a9891b.less";


//////////////////
// WEBPACK FOOTER
// ./src/css/home.less
// module id = 2015
// module chunks = 2